import { render, staticRenderFns } from "./DigitalClock.vue?vue&type=template&id=6915e7f1&scoped=true"
import script from "./DigitalClock.vue?vue&type=script&lang=js"
export * from "./DigitalClock.vue?vue&type=script&lang=js"
import style0 from "./DigitalClock.vue?vue&type=style&index=0&id=6915e7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915e7f1",
  null
  
)

export default component.exports